export const AUTHENTICATION_PATHS = {
    login: "/login",
    signup: "/signup",
    resetPassword: "/reset-password",
    logout: "/logout",
    root: "/"

}